import type { StockTransferListRow } from "@/modules/inventory/presentation/api/client";
import { TRANSFER_STATUS_LABELS } from "@/modules/inventory/presentation/ui/transfers/TransferStatusBadge";

export function downloadTransfersCsv(
  items: StockTransferListRow[],
  filename = "stock-transfers.csv",
) {
  const header = [
    "ເລກທີ",
    "ສະຖານະ",
    "ສາຂາຂໍ",
    "Hub",
    "ຈຳນວນບັນທັດ",
    "ວັນທີສົ່ງຄຳຂໍ",
    "ວັນທີຈັດສົ່ງ",
    "ວັນທີຮັບ",
  ];
  const rows = items.map((r) =>
    [
      r.requestNo,
      TRANSFER_STATUS_LABELS[r.status],
      `${r.fromBranchCode} ${r.fromBranchName}`,
      `${r.toBranchCode} ${r.toBranchName}`,
      String(r.lineCount),
      r.submittedAt ?? "",
      r.shippedAt ?? "",
      r.receivedAt ?? "",
    ]
      .map((cell) => `"${String(cell).replace(/"/g, '""')}"`)
      .join(","),
  );
  const csv = [header.join(","), ...rows].join("\n");
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
